import React from "react";
import ReactDOM from "react-dom/client";
import { BrandSystem } from "./BrandSystem";
import "./styles/globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrandSystem />
  </React.StrictMode>,
);
